import { QueryClient } from "@tanstack/react-query";
import { getErrorStatus } from "@/api/problemDetails";

export const shouldRetryQuery = (failureCount: number, error: unknown): boolean => {
  const status = getErrorStatus(error);
  if (status !== undefined && status >= 400 && status < 500) return false;
  return failureCount < 1;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetryQuery,
      refetchOnWindowFocus: true,
    },
  },
});
